module.exports = __webpack_public_path__ + "static/media/mix-match-view.5283f62a.jpg";